
import { mapActions } from 'vuex'
import LoleSelect from '~/components/form/select/lole-select'
export default {
  components: { LoleSelect },
  props: {
    item: {
      type: Object,
      required: true,
    },
    wording: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedSize: null,
      noSelectedSize: false,
      selectedColor: null,
      addedToCart: false,
    }
  },
  computed: {
    sizeDataObj() {
      return this.selectedSize
        ? this.item.sizes.filter((size) => size.name === this.selectedSize)[0]
        : null
    },
    isOutOfStock() {
      if (!this.item.sizes) return false
      if (parseFloat(this.item.price) === 0) return true
      const sizeAvailble = this.item.sizes.filter((size) => {
        return size.availability
      })
      return sizeAvailble.length > 0
    },
  },
  methods: {
    ...mapActions({
      vxAddProductsToCart: 'product/addProductsToCart',
    }),
    selectSize() {
      const size = this.sizeDataObj
      if (!size.availability) return
      this.addedToCart = false
      this.noSelectedSize = false
    },
    addToCart() {
      let size = this.sizeDataObj
      if (this.isOnlySizeProduct()) size = this.item.sizes[0]
      if (!size) {
        this.noSelectedSize = true
        return
      }
      this.vxAddProductsToCart({
        products: [
          {
            product: this.item,
            variant: {
              size_name: size.name,
              id: size.id,
              barcode: size.barcode,
              sku: size.sku,
              quantity: 1,
            },
          },
        ],
        location: 'product-page',
      })
      this.$googleAnalyticsEvents.GA4AddToCart(this.product)
      this.addedToCart = true
    },
    isOnlySizeProduct() {
      return this.item.sizes.length < 2
    },
  },
}
